import React, { useEffect } from "react";
import CustomizedProgressBars from "../progressBar/index";
import { DataGrid } from "@mui/x-data-grid";
import Button from "@mui/material/Button";
import { Wrapper } from "../../../components/common/BaseDataTable/style";

export function GridDocPlace(props) {
  const selectOption = (op, id, row) => {
    optionSelect({ action: op, id: id, row: row });
  };

  const optionSelect = (event) => {
    props.option(event);
  };

  const selectOption2 = (op, id, row) => {
    optionSelect2({ action: op, id: id, row: row });
  };

  const optionSelect2 = (event) => {
    props.option2(event);
  };

  useEffect(() => {
    if (props.data) {
      console.log(props.data);
    }
  }, [props.data]);

  const dateComparator = (v1, v2, param1, param2) => {
    const parseDate = (dateString) => {
      if (!dateString) return null;
      const [datePart, timePartWithAMPM] = dateString.split(", ");
      if (!datePart || !timePartWithAMPM) return null;

      const [timePart, ampm] = timePartWithAMPM.split(" ");
      if (!timePart || !ampm) return null;

      const [month, day, year] = datePart.split("/");
      let [hours, minutes, seconds] = timePart.split(":");

      if (!month || !day || !year || !hours || !minutes || !seconds)
        return null;

      hours = parseInt(hours, 10);
      if (ampm.toUpperCase() === "PM" && hours < 12) {
        hours += 12;
      } else if (ampm.toUpperCase() === "AM" && hours === 12) {
        // Medianoche
        hours = 0;
      }

      return new Date(
        year,
        parseInt(month, 10) - 1,
        day,
        hours,
        minutes,
        seconds
      );
    };

    const date1 = parseDate(v1);
    const date2 = parseDate(v2);

    if (date1 === null && date2 === null) {
      return 0;
    }
    if (date1 === null) {
      return -1;
    }
    if (date2 === null) {
      return 1; // o -1
    }

    if (date1 < date2) {
      return -1;
    }
    if (date1 > date2) {
      return 1;
    }
    return 0;
  };

  const headCols = [
    {
      field: "name",
      flex: 1,
      headerClassName: "MuiTableHead-root",
      headerName: "Name",
      renderCell: (params) => {
        console.log(params);
        return (
          <div
            style={{
              width: "100%",
              lineHeight: "1.2",
              padding: "4px 0",
            }}
          >
            <div
              style={{
                width: "100%",
                whiteSpace: "normal",
                wordBreak: "break-word",
                fontWeight: 600,
              }}
            >
              {params.row.name}
            </div>
            <div
              style={{
                fontSize: "0.7rem",
                width: "100%",
                color: "#666",
                whiteSpace: "normal",
                marginTop: "4px",
                wordBreak: "break-word",
                lineHeight: "1.1",
              }}
            >
              To: {params.row.signersList}
            </div>
          </div>
        );
      },
    },
    {
      field: "lastUpdated",
      headerClassName: "MuiTableHead-root",
      headerName: "Last Updated",
      minWidth: 180,
      width: 180,
      sortComparator: dateComparator,
      disableColumnResizable: true,
    },
    {
      field: "status",
      headerClassName: "MuiTableHead-root",
      headerName: "Status",
      minWidth: 180,
      width: 180,
      disableColumnResizable: true,
      renderCell: (params) => {
        const signedSigners = params?.row?.signers.filter(
          (signer) => signer.have_signed === 1
        );

        let progress =
          (signedSigners.length / params?.row?.signers.length) * 100;
        if (!Number.isFinite(progress)) {
          progress = 0;
        }

        return (
          <div
            style={{
              width: "100%",
              lineHeight: "1.2",
              padding: "4px 0",
            }}
          >
            <div
              style={{
                width: "100%",
                whiteSpace: "normal",
                wordBreak: "break-word",
                fontWeight: 600,
              }}
            >
              <CustomizedProgressBars progress={progress} />
            </div>
            <div
              style={{
                fontSize: "0.7rem",
                width: "100%",
                color: "#666",
                whiteSpace: "normal",
                marginTop: "4px",
                wordBreak: "break-word",
                lineHeight: "1.1",
              }}
            >
              {params.row.nextSigner && `Next: ${params.row.nextSigner}`}
            </div>
          </div>
        );
      },
    },
    {
      field: "actions", // Fixed typo in field name
      headerName: "Action",
      sortable: false,
      headerClassName: "MuiTableHead-root",
      minWidth: 100,
      width: 100,
      disableColumnResizable: true,
      renderCell: (params) => (
        <>
          {params.row.isStamp === "signed" ? (
            <Button
              variant="outlined"
              sx={{
                backgroundColor: "#C1E2FF",
                border: "none",
                color: "#0076FF",
                fontWeight: "bold",
                textTransform: "none",
              }}
              onClick={() => selectOption2("edit", params.id, params)}
            >
              View
            </Button>
          ) : (
            <Button
              variant="outlined"
              sx={{
                backgroundColor: "#C1E2FF",
                border: "none",
                color: "#0076FF",
                fontWeight: "bold",
                textTransform: "none",
              }}
              onClick={() => selectOption("edit", params.id, params)}
            >
              Sign
            </Button>
          )}
        </>
      ),
    },
  ];
  return (
    <Wrapper>
      <DataGrid
        rows={props.data}
        columns={headCols}
        pageSize={10}
        density="standard"
        rowsPerPageOptions={[5]}
        sx={{
          "& .MuiDataGrid-cell:focus": {
            outline: "none",
          },
          "& .MuiDataGrid-cell": {
            paddingInline: "8px !important",
          },
          "& .MuiDataGrid-columnHeader:focus": {
            outline: "none",
          },
          "& .MuiTableHead-root": {
            backgroundColor: "#0076FF",
            color: "#fff",
          },
          "& .MuiTableCell-head": {
            paddingInline: "8px !important",
            color: "#fff !important",
            backgroundColor: "#0076FF !important",
            border: 0,
            fontWeight: "bold !important",
          },
          // "& .MuiTableCell-row": {
          //   paddingLeft: "2px",
          // },
          backgroundColor: "#fff",
          height: "full",
        }}
        sortingOrder={["asc", "desc"]}
        getRowClassName={() => `MuiTableCell-row`}
        initialState={{
          sorting: {
            sortModel: [{ field: "lastUpdated", sort: "desc" }],
          },
        }}
      />
    </Wrapper>
  );
}

export default GridDocPlace;
